import { render } from "./VRadioModified.vue?vue&type=template&id=52a341ea"
import script from "./VRadioModified.vue?vue&type=script&lang=js"
export * from "./VRadioModified.vue?vue&type=script&lang=js"

import "./VRadioModified.vue?vue&type=style&index=0&id=52a341ea&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__